import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Text } from '@dixa/lib-shared-habla';
import styles from './documentationLink.module.scss';
export function DocumentationLink() {
    return (_jsxs(Text.ExternalLink, Object.assign({ className: styles.root, href: "https://messenger-docs.dixa.io", rel: "noopener noreferrer", target: "_blank" }, { children: [_jsx("span", { children: "Read the developer documentation" }), ' ', _jsx(Icon, { name: "external-link" })] })));
}
